(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cc-cart-quick-add"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-cart-quick-add')) {
    customElements.define('cc-cart-quick-add', class extends HTMLElement {
      static pending = false;
      connectedCallback() {
        this.button = this.querySelector('.cc-quick-add__button');
        this.variant = this.querySelector('[data-cc-variant]');
        this.error = this.querySelector('.cc-quick-add__error');
        this.querySelector('.cc-quick-add__recover').addEventListener('click', () => location.reload());
        this.button.addEventListener('click', () => this.add());
        this.variant.addEventListener('change', () => {
          const price = this.variant.selectedOptions?.[0]?.dataset.price;
          if (price) this.closest('.cc-look-card').querySelector('.cc-look-card__price').textContent = price;
        });
      }
      async add() {
        if (this.constructor.pending || this.button.disabled) return;
        if (!this.variant.value) { this.variant.reportValidity(); return; }
        this.constructor.pending = true;
        this.button.disabled = true;
        this.setAttribute('aria-busy', 'true');
        const label = this.button.textContent;
        this.button.textContent = this.dataset.adding;
        this.error.hidden = true;
        const cartForm = this.closest('cart-form');
        const header = document.querySelector('page-header');
        const sectionIds = [cartForm?.dataset.sectionId, header?.dataset.sectionId].filter(Boolean);
        const sourceId = this.closest('cc-look-panel').dataset.sourceId;
        let safeToRetry = false;
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
            body: JSON.stringify({items: [{id: this.variant.value, quantity: 1}], sections: sectionIds, sections_url: location.pathname})
          });
          const data = await response.json();
          if (!response.ok) {
            safeToRetry = response.status === 422 || response.status === 400;
            throw new Error(safeToRetry ? (data.description || this.dataset.error) : this.dataset.uncertain);
          }
          if (!data.sections?.[cartForm.dataset.sectionId]) throw new Error(this.dataset.uncertain);
          const status = document.querySelector('[data-cc-cart-status]');
          if (status) { status.textContent = this.dataset.added; status.hidden = false; }
          if (header && data.sections[header.dataset.sectionId]) header.updateFromCartChange(data.sections[header.dataset.sectionId]);
          cartForm.refreshFromHtml(data.sections[cartForm.dataset.sectionId]);
          const nextPanel = Array.from(cartForm.querySelectorAll('cc-look-panel')).find(panel => panel.dataset.sourceId === sourceId && !panel.hidden);
          const focusTarget = nextPanel?.querySelector('h2') || status;
          focusTarget?.focus({preventScroll: true});
        } catch (error) {
          this.error.textContent = safeToRetry ? error.message : this.dataset.uncertain;
          this.error.hidden = false;
          this.querySelector('.cc-quick-add__recover').hidden = safeToRetry;
          this.button.disabled = !safeToRetry;
        } finally {
          this.constructor.pending = false;
          this.removeAttribute('aria-busy');
          this.button.textContent = label;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cc-collection-loading"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-collection-loading')) {
    customElements.define('cc-collection-loading', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        this.grid = this.section.querySelector('.collection-listing .product-grid');
        if (!this.grid || !('IntersectionObserver' in window)) return;
        this.key = location.pathname + location.search;
        this.button = this.querySelector('button');
        this.status = this.querySelector('[role="status"]');
        this.fallback = this.querySelector('.cc-collection-loading__fallback');
        this.label = this.button.textContent;
        this.pages = [];
        this.autoCount = 0;
        this.next = this.dataset.next;
        this.querySelector('.cc-collection-loading__controls').hidden = false;
        this.querySelector('.cc-collection-loading__pagination').hidden = true;
        this.onClick = () => { this.autoCount = 2; this.load(false); };
        this.button.addEventListener('click', this.onClick);
        this.save = () => {
          if (!this.isConnected || this.restoring || this.key !== location.pathname + location.search) return;
          history.replaceState({ ...history.state, ccCollection: { key: this.key, pages: this.pages, autoCount: this.autoCount, y: scrollY } }, '', location.href);
        };
        this.onLeave = (event) => { if (event.target.closest('a, input, select, button')) this.save(); };
        this.section.addEventListener('click', this.onLeave, true);
        this.section.addEventListener('change', this.save, true);
        addEventListener('pagehide', this.save);
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting) && this.autoCount < 2 && !this.restoring) this.load(true);
        }, { rootMargin: '0px 0px 300px 0px' });
        requestAnimationFrame(() => { if (this.isConnected) this.restore(); });
      }
      async restore() {
        const saved = history.state?.ccCollection;
        this.restoring = true;
        if (saved?.key === this.key && Array.isArray(saved.pages)) {
          for (const url of saved.pages) {
            if (!this.isConnected || !this.next || !(await this.load(false, url))) break;
          }
          this.autoCount = saved.autoCount || 0;
          if (this.isConnected && this.key === location.pathname + location.search) {
            requestAnimationFrame(() => { if (this.isConnected) window.scrollTo({ top: saved.y || 0, behavior: 'instant' }); });
          }
        }
        this.restoring = false;
        this.update();
      }
      update() {
        this.button.hidden = !this.next;
        this.button.disabled = false;
        this.button.textContent = this.label;
        if (!this.next) {
          this.status.classList.remove('visually-hidden');
          this.status.textContent = this.dataset.end;
        }
        this.observer.disconnect();
        if (this.next && this.autoCount < 2 && !this.restoring) this.observer.observe(this);
      }
      async load(automatic, restoreUrl) {
        if (this.busy || !this.next || !this.isConnected || this.key !== location.pathname + location.search || this.grid.closest('.ajax-loading')) return false;
        const url = new URL(restoreUrl || this.next, location.href);
        if (url.origin !== location.origin || url.pathname !== location.pathname) return false;
        const pageUrl = url.pathname + url.search;
        if (this.pages.includes(pageUrl)) return false;
        this.busy = true;
        this.observer.disconnect();
        this.button.disabled = true;
        this.button.textContent = this.dataset.loading;
        this.status.textContent = this.dataset.loading;
        this.status.classList.add('visually-hidden');
        this.fallback.hidden = true;
        this.grid.setAttribute('aria-busy', 'true');
        this.abort = new AbortController();
        url.searchParams.set('section_id', this.dataset.section);
        try {
          const response = await fetch(url, { signal: this.abort.signal });
          if (!response.ok) throw new Error('Collection request failed');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = page.querySelector('.collection-listing .product-grid');
          const paging = page.querySelector('cc-collection-loading');
          if (!incoming || !paging) throw new Error('Collection response incomplete');
          if (!this.isConnected || this.key !== location.pathname + location.search || this.grid.closest('.ajax-loading')) return false;
          const cardKey = card => card.dataset.productId ? `product:${card.dataset.productId}` : card.querySelector('a[href]')?.getAttribute('href');
          const known = new Set([...this.grid.children].map(cardKey).filter(Boolean));
          const fragment = document.createDocumentFragment();
          let first;
          [...incoming.children].forEach(card => {
            const key = cardKey(card);
            if (!key || known.has(key)) return;
            known.add(key);
            if (card.hasAttribute('data-cc-animate')) { card.removeAttribute('data-cc-animate'); card.style.opacity = '1'; }
            card.querySelectorAll('[data-cc-animate]').forEach(el => { el.removeAttribute('data-cc-animate'); el.style.opacity = '1'; });
            card.querySelectorAll('img').forEach(img => { img.loading = 'lazy'; img.removeAttribute('fetchpriority'); });
            first ||= card.querySelector('a[href]');
            fragment.append(card);
          });
          this.grid.append(fragment);
          this.pages.push(pageUrl);
          this.next = paging.dataset.next;
          if (automatic) this.autoCount += 1;
          this.status.textContent = this.dataset.loaded;
          if (!automatic && !this.restoring && first) first.focus({ preventScroll: true });
          this.save();
          return true;
        } catch (error) {
          if (error.name !== 'AbortError' && this.isConnected) {
            this.autoCount = 2;
            this.status.textContent = this.dataset.error;
            this.status.classList.remove('visually-hidden');
            this.fallback.href = this.next;
            this.fallback.hidden = false;
          }
          return false;
        } finally {
          this.busy = false;
          this.grid.removeAttribute('aria-busy');
          if (this.isConnected) this.update();
        }
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.button?.removeEventListener('click', this.onClick);
        this.section?.removeEventListener('click', this.onLeave, true);
        this.section?.removeEventListener('change', this.save, true);
        if (this.save) removeEventListener('pagehide', this.save);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cc-compact-header"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-compact-header')) {
    customElements.define('cc-compact-header', class extends HTMLElement {
      connectedCallback() {
        this.header = this.closest('page-header');
        this.section = this.closest('.section-header');
        this.desktop = matchMedia('(min-width: 1200px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.queue = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        };
        this.resize = () => { this.animation?.cancel(); this.transitioning = false; this.setCompact(false, false); this.queue(); };
        addEventListener('scroll', this.queue, { passive: true });
        addEventListener('resize', this.resize, { passive: true });
        this.header.addEventListener('focusout', this.queue);
        this.queue();
      }
      update() {
        if (this.transitioning) return;
        if (!this.desktop.matches) { this.setCompact(false, false); return; }
        if (!this.compact) this.expanded = this.section.offsetHeight;
        const next = this.compact ? scrollY > 16 : scrollY > 64;
        if (this.header.contains(document.activeElement) || document.body.classList.contains('show-search')) return;
        this.setCompact(next, true);
      }
      async setCompact(next, animate) {
        if (Boolean(this.compact) === next) return;
        const motion = animate && !this.reduced.matches;
        this.transitioning = motion;
        if (motion) {
          this.animation = this.header.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 90, easing: 'ease-out', fill: 'forwards' });
          try { await this.animation.finished; } catch { return; }
        }
        this.compact = next;
        if (next) this.section.style.setProperty('--cc-expanded-header', `${this.expanded}px`);
        this.section.classList.toggle('cc-header-reserved', next);
        this.header.classList.toggle('cc-header-compact', next);
        if (!next) window.theme?.inlineNavigationCheck?.();
        if (motion) {
          this.animation.cancel();
          this.animation = this.header.animate([{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'none' }], { duration: 180, easing: 'cubic-bezier(.2,.7,.2,1)' });
          try { await this.animation.finished; } catch { return; }
        }
        this.transitioning = false;
        this.queue();
      }
      disconnectedCallback() {
        removeEventListener('scroll', this.queue);
        removeEventListener('resize', this.resize);
        this.header.removeEventListener('focusout', this.queue);
        cancelAnimationFrame(this.frame);
        this.animation?.cancel();
        this.setCompact(false, false);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cc-look-feedback"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-look-feedback')) {
    customElements.define('cc-look-feedback', class extends HTMLElement {
      connectedCallback() {
        this.drawer = this.closest('cart-drawer');
        this.reset = () => { this.hidden = true; };
        this.announce = () => {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
          this.hidden = false;
          const content = this.drawer?.querySelector('.cart-drawer__content');
          content?.scrollTo({top: 0, behavior: 'instant'});
          clearTimeout(this.timer);
          this.timer = setTimeout(this.reset, 6000);
        };
        document.addEventListener('on:cart:add', this.announce);
        this.drawer?.addEventListener('on:cart-drawer:before-open', this.reset);
      }
      disconnectedCallback() {
        document.removeEventListener('on:cart:add', this.announce);
        this.drawer?.removeEventListener('on:cart-drawer:before-open', this.reset);
        clearTimeout(this.timer);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cc-look-panel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-look-panel')) {
    customElements.define('cc-look-panel', class extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('.cc-look-panel__grid');
        if (this.dataset.context !== 'product' && this.grid) {
          this.controls = this.querySelector('.cc-look-panel__controls');
          this.prev = this.querySelector('[data-cc-prev]');
          this.next = this.querySelector('[data-cc-next]');
          this.updateControls = () => {
            const max = this.grid.scrollWidth - this.grid.clientWidth;
            const position = Math.abs(this.grid.scrollLeft);
            this.controls.hidden = max < 2;
            this.prev.disabled = position < 2;
            this.next.disabled = position >= max - 2;
          };
          this.slide = direction => {
            const step = this.grid.firstElementChild.getBoundingClientRect().width + 12;
            const rtl = getComputedStyle(this.grid).direction === 'rtl' ? -1 : 1;
            this.grid.scrollBy({left: direction * step * rtl, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          };
          this.prev.addEventListener('click', () => this.slide(-1));
          this.next.addEventListener('click', () => this.slide(1));
          this.grid.addEventListener('scroll', this.updateControls, {passive: true});
          this.resizeObserver = new ResizeObserver(this.updateControls);
          this.resizeObserver.observe(this.grid);
          this.updateControls();
        }
        if (this.dataset.context !== 'product') return;
        this.refreshListener = () => {
          clearTimeout(this.refreshTimer);
          this.refreshTimer = setTimeout(() => this.refresh(), 150);
        };
        document.addEventListener('on:cart:after-merge', this.refreshListener);
        document.addEventListener('on:cart:change', this.refreshListener);
      }
      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.grid?.removeEventListener('scroll', this.updateControls);
        clearTimeout(this.refreshTimer);
        this.controller?.abort();
        document.removeEventListener('on:cart:after-merge', this.refreshListener);
        document.removeEventListener('on:cart:change', this.refreshListener);
      }
      async refresh() {
        this.controller?.abort();
        this.controller = new AbortController();
        try {
          const response = await fetch(this.dataset.refreshUrl, {signal: this.controller.signal, cache: 'no-store'});
          if (!response.ok) throw new Error('Unavailable');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const replacement = page.querySelector('cc-look-panel[data-context="product"]');
          if (!replacement) { this.hidden = true; return; }
          const focusedId = this.contains(document.activeElement) ? document.activeElement.id : null;
          this.innerHTML = replacement.innerHTML;
          this.hidden = replacement.hidden;
          if (focusedId) document.getElementById(focusedId)?.focus();
        } catch (error) {
          if (error.name !== 'AbortError') this.hidden = true;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
